import * as React from 'react';
import classnames from 'classnames';
import MediaManager from '../../libraries/mediaLibrary/MediaManager';
import { INCA_LOGO_URL } from '@nexxt/common/constants';
import { UilPen } from '@iconscout/react-unicons';

interface IBotAvatarImageProps {
    setSelectedMedia: ({ src }) => void;
    avatarImage?: string;
    disabled?: boolean;
    showTitle?: boolean;
}

const BotAvatar: React.SFC<IBotAvatarImageProps> = ({
    setSelectedMedia,
    avatarImage,
    disabled,
    showTitle
}) => {
    const [showMediaManager, setShowMediaManager] = React.useState(false);
    return (
        <div
            className={classnames('form-group', {
                disabled
            })}
        >
            {showTitle && (
                <label className="form-group__label form-group__label--block">
                    Bot Interviewer Avatar
                </label>
            )}
            <span className="form-group__icon">
                <MediaManager
                    showMediaManager={showMediaManager}
                    toggleMediaManager={setShowMediaManager}
                    showMediaLibrary
                    type="image"
                    applyCurrentMedia={({ mediaURL }) =>
                        setSelectedMedia({ src: mediaURL })
                    }
                >
                    <div>
                        <img src={avatarImage ? avatarImage : INCA_LOGO_URL} />
                        <div
                            className="hover-container"
                            onClick={() =>
                                !disabled && setShowMediaManager(true)
                            }
                        >
                            {!disabled && (
                                <div className="hover-container--item">
                                    <UilPen size={16} />
                                </div>
                            )}
                        </div>
                    </div>
                </MediaManager>
            </span>
        </div>
    );
};

export default BotAvatar;
